var MomoConfig = {
    service: {
        startDate: "2023-02-01",        // 서비스 시작일
        showPrevYearMonth: 3,           // 3월까지는 전년도 통계 확인 가능
    }
};
module.exports = MomoConfig;
